import { style } from '@vtex/admin-ui'

export const skeletonRow = style({
  width: '16px',
  height: '16px',
  alignItems: 'center',
  justifyContent: 'center',
})

export const skeletonDot = style({ height: '0.875rem', width: '0.875rem' })
